import React, { useEffect, useState } from "react";
import {
  getAttendanceDetails,
  getDailyVisitDetails,
} from "_controllers/officer";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  Button,
  Typography,
  TableContainer,
  Paper,
  Grid,
  TextField,
  CircularProgress,
  Chip,
  IconButton,
} from "@mui/material";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import { Box } from "@mui/system";
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: 520 },
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const DailyVist = () => {
  const { SAP_ID } = useParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [visitDetails, setVisitDetails] = useState([])
  const [message, setMessage] = useState("");
  const [onDate, setOnDate] = useState('')

  // const { ondate } = Values

  useEffect(async () => {
    const todayDate = onDate ? onDate : moment(new Date()).format("YYYY-MM-DD");

    const plan = await getDailyVisitDetails({
      SAP_ID,
      todayDate,
    });
    console.log("object", plan.newData);
    setData(plan?.newData);
    setLoading(true);
  }, [message, onDate]);

  const timeSpent = (a, b) => {
    const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")));
    return `${test.asMinutes().toFixed(0)} mins`;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setOnDate(e.target.value)
  }

  const displayDate = onDate ? onDate : moment(new Date()).format("YYYY-MM-DD");

  return (
    <>
      <PageHeader
        title="Daily Visit"
        subtitle={`Visit log for SAP ID ${SAP_ID}`}
      />

      <SectionCard sx={{ mb: 3 }}>
        <Box component="form">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm="auto">
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                On Date
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                type="date"
                size="small"
                fullWidth
                onChange={handleChange}
                value={onDate}
                name="onDate"
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      </SectionCard>

      {loading ? (
        <SectionCard disablePadding>
          <TableContainer component={Paper} elevation={0} sx={{ overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="left">Dealer Code</TableCell>
                  <TableCell align="left">Dealer Details</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="center">Visit Action</TableCell>
                  <TableCell align="center">Time Spent</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length > 0
                  ? data?.map((d) => {
                    const isDeleted = d.deleted === true;
                    const strike = isDeleted
                      ? { textDecoration: "line-through" }
                      : undefined;
                    return (
                      <TableRow key={d._id}>
                        <TableCell align="left" sx={strike}>
                          {moment(d?.startTime).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell align="left" sx={strike}>{d?.dealerCode}</TableCell>
                        <TableCell align="left" sx={strike}>{d?.dealerDetails?.name}</TableCell>
                        <TableCell align="left">
                          <Chip
                            size="small"
                            label={d?.unplanned ? "Unplanned" : "Planned"}
                            color={d?.unplanned ? "error" : "success"}
                            variant="filled"
                            sx={isDeleted ? { textDecoration: "line-through" } : undefined}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setOpen(true);
                              setVisitDetails(d?.visitActions);
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center" sx={strike}>
                          {isDeleted ? "NA" : timeSpent(d?.startTime, d?.endTime)}
                        </TableCell>
                      </TableRow>
                    );
                  })
                  : (
                    <TableRow>
                      <TableCell colSpan={6} sx={{ borderBottom: "none" }}>
                        <EmptyState
                          icon={EventBusyOutlinedIcon}
                          title="No visits available"
                          description={`There are no visits recorded on ${displayDate}.`}
                        />
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={messageStyle}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Type</TableCell>
                <TableCell>Action Taken</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visitDetails?.length > 0 ? (
                visitDetails.map((row) => (
                  <TableRow key={row._id}>
                    <TableCell align="left" scope="row">{row?.type}</TableCell>
                    <TableCell align="center" scope="row">{row?.actionTaken}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow key={'1'}>
                  <TableCell colSpan={3} align="center">
                    No Visit Action Available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DailyVist;
